const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "회사소개",
    "termsOfService": "이용약관",
    "privacyPolicy": "개인정보처리방침",
    "guaranteeOfRights": "정보주체의 권리보장",
    "customerSupport": "고객지원",
    "cookiePolicy": "쿠키정책",
    "declarationOfSafety": "안심・안전 선언",
    "youthProtectionPolicy": "청소년보호정책",
    "communityPolicy": "커뮤니티정책",
    "probability": "NC확률정보",
    "operationPolicy": "운영정책",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "회원정책",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC 프라이버시 센터",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "NCSOFT 서비스 동의",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "게임 관련 볍령에 따른 추가 표기",
    "brandInformation": "상호정보",
    "copyright": "카피라이트",
    "channelingInfo": "(주)엔씨소프트는 plaync 내 채널링 게임의 제공을 중개하는 통신판매중개자이며 통신판매의 당사자가 아닙니다.<br>채널링 게임의 제공과 관련된 모든 의무와 책임은 개별 통신판매업자에게 있으며, 이와 관련하여 발생하는 문제에 대해 당사는 책임을 부담하지 않습니다."
  },
  "infoCS": {
    "businessInformation": "사업자정보확인",
    "infoAddress": "상호 (주)엔씨소프트 공동 대표 김택진, 박병무 사업자 등록번호 144-85-04244 통신판매업신고 제2013-경기성남-1268호",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1566-7004 팩스 02-2186-3499",
    "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3550",
    "other": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020(PC게임), 1566-7004(모바일게임) 팩스 02-2186-3550(PC게임), 02-2186-3499(모바일게임)",
    "none": "",
    "infoEmail": "이메일",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(PC게임)/MobileCS@ncsoft.com/(모바일게임)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "타이틀",
    "jpGenre": "장르",
    "jpPrice": "가격",
    "jpPriceValue": "무료 (인 앱 결제 상품 포함)",
    "jpOs": "대응OS",
    "jpDevelopedBy": "개발처/운영처",
    "jpReleaseDay": "릴리즈일",
    "jpReleaseDayValue_LW": "2021년 11월 4일"
  },
  "country": {
    "KR": "대한민국",
    "TW": "대만",
    "RU": "러시아",
    "MY": "말레이시아",
    "SA": "사우디아라비아",
    "SG": "싱가포르",
    "AE": "아랍에미리트",
    "ID": "인도네시아",
    "JP": "일본",
    "QA": "카타르",
    "TH": "태국",
    "PH": "필리핀",
    "HK": "홍콩",
    "UA": "우크라이나",
    "BY": "벨라루스",
    "LT": "리투아니아",
    "PL": "폴란드",
    "GR": "그리스",
    "IL": "이스라엘",
    "KW": "쿠웨이트",
    "AT": "오스트리아",
    "US": "미국",
    "CA": "캐나다",
    "DE": "독일",
    "GB": "영국",
    "FR": "프랑스",
    "BR": "브라질",
    "IT": "이탈리아",
    "ES": "스페인",
    "CL": "칠레",
    "NO": "노르웨이",
    "SE": "스웨덴",
    "IE": "아일랜드",
    "PT": "포르투갈",
    "FI": "핀란드",
    "DK": "덴마크",
    "CH": "스위스",
    "AR": "아르헨티나",
    "PE": "페루",
    "MX": "멕시코",
    "KZ": "카자흐스탄",
    "UZ": "우즈베키스탄",
    "AZ": "아제르바이잔",
    "GE": "조지아",
    "MD": "몰도바",
    "AM": "아르메니아",
    "MO": "마카오",
    "IN": "인도",
    "PK": "파키스탄",
    "NL": "네덜란드",
    "RO": "루마니아",
    "AU": "호주",
    "TR": "튀르키예",
    "EC": "에콰도르",
    "CO": "콜롬비아",
    "ZA": "남아프리카공화국",
    "EG": "이집트",
    "NC": "Global"
  }
};

export default l10n;
